import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const reportScheduleRunConverter = {
  toFirestore(run: ReportSchedules.Run): firebase.firestore.DocumentData {
    return { ...run };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): ReportSchedules.Run {
    return snapshot.data(options) as ReportSchedules.Run;
  },
};

// Runs live under the schedule:
// accounts/{accountId}/reportSchedules/{scheduleId}/reportScheduleRuns/{runId}
const getReportScheduleRunsRef = ({
  accountId,
  scheduleId,
  db,
}: {
  accountId: string;
  scheduleId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.REPORT_SCHEDULES_COLLECTION)
    .doc(scheduleId)
    .collection(STORE_CONSTANTS.REPORT_SCHEDULE_RUNS_COLLECTION)
    .withConverter(reportScheduleRunConverter);
};

export default getReportScheduleRunsRef;
